import Vue from 'vue'
import VueI18n from 'vue-i18n'
import de, { dateTimeFormat as dateTimeFormatDe } from './de'
import en, { dateTimeFormat as dateTimeFormatEn } from './en'

import { formatDistanceToNow } from 'date-fns'
import { de as dateLocaleDe } from 'date-fns/locale'

Vue.use(VueI18n)

// Vue.use(VueTimeago, {
//   name: 'Timeago', // Component name, `Timeago` by default
//   locale: 'de', // Default locale
//   // We use `date-fns` under the hood
//   // So you can use all locales from it
//   locales: {
//     de: require('date-fns/locale/de'),
//     en: require('date-fns/locale/en-US'),
//   },
// })

export function distanceInWords(date: Date) {
  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: dateLocaleDe,
  })
}

export const i18n = new VueI18n({
  dateTimeFormats: {
    ...dateTimeFormatDe,
    ...dateTimeFormatEn,
  },
  locale: 'de',
  messages: {
    de,
    en,
  },
  silentTranslationWarn: true,
})
